import workspaceQuery from '../../queries/sales/HaulierWorkspaceQuery.graphql';
import listQuery from '../../queries/sales/HaulierListQuery.graphql';
import instanceQuery from '../../queries/sales/HaulierQuery.graphql';
import defaultQuery from '../../queries/sales/HaulierDefault.graphql';
import mutationQuery from '../../mutations/sales/HaulierMutation.graphql';
import fragment from '../../fragments/sales/HaulierFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const Haulier: EntityType = {
  type: 'Haulier',
  title: 'Hauliers',
  formTitle: 'Haulier',
  formUrl: '/Sales/Haulier/Details/',
  workspaceUrl: '/Sales/Haulier/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_HAULIERS',
};

export default Haulier;
